export default {
  main: '#000000',
  secondary: '#d3ae7a',
  contrastingColor: '#ffffff',
  priceColor: '#d3ae7a',
  entryBackground: '#000000',
  menuBackgroundColor: '#ffffff',
  menuTextColor: '#000000',
};
